import React from 'react';
import { useIsMobile } from '@/lib/utils/useIsMobile';
import { People } from '@/pages/members';
import { MobileMembers } from '@/pages/MobileMembers';

export function ResponsiveMembers() {
  const isMobile = useIsMobile();
  
  if (isMobile) {
    return <MobileMembers />;
  }
  
  return <People />;
}